(function () {
  function initSwiper(container) {
    if (!container || container.dataset.swiperInit === 'true') return;
    var retry = 0;

    var swiperEl = container.querySelector('.ymal-swiper');
    var perView  = parseInt((swiperEl && swiperEl.dataset.slidesPerView) || '4', 10);

    function tryInit() {
      if (typeof Swiper === 'undefined') {
        if (retry++ > 10) return;
        setTimeout(tryInit, 50);
        return;
      }
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
          prevEl: container.querySelector('.ymal-btn--prev'),
          nextEl: container.querySelector('.ymal-btn--next'),
        },
        breakpoints: {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          750: { slidesPerView: 3 },
          990: { slidesPerView: perView }
        }
      });
      container.dataset.swiperInit = 'true';
    }
    tryInit();
  }

  function fetchRecommendations(placeholder) {
    var sectionId = placeholder.dataset.sectionId;
    var productId = placeholder.dataset.productId;
    var limit     = parseInt(placeholder.dataset.limit, 10) || 8;
    var url = '/recommendations/products?section_id=' + sectionId +
              '&product_id=' + productId +
              '&limit=' + limit +
              '&intent=related';

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fetched = temp.querySelector('.ymal-section:not(.ymal-section--placeholder)');
        if (fetched && fetched.querySelector('.swiper-slide')) {
          placeholder.insertAdjacentHTML('afterend', fetched.outerHTML);
          var newSection = placeholder.nextElementSibling;
          placeholder.remove();
          if (newSection) initSwiper(newSection);
        } else {
          placeholder.style.display = 'none';
        }
      })
      .catch(function () {
        placeholder.style.display = 'none';
      });
  }

  function observeAndLoad(placeholder) {
    if (!('IntersectionObserver' in window)) {
      fetchRecommendations(placeholder);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          fetchRecommendations(entry.target);
        }
      });
    }, { rootMargin: '50px' });
    observer.observe(placeholder);
  }

  document.querySelectorAll('.ymal-section').forEach(function (section) {
    if (!section.classList.contains('ymal-section--placeholder')) {
      initSwiper(section);
    }
  });

  document.querySelectorAll('.ymal-section--placeholder').forEach(function (placeholder) {
    observeAndLoad(placeholder);
  });

})();